import React, { useState } from 'react';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import { toast } from 'react-toastify';
import StandardButton from '../../../components/buttons/Base/StandardButton';
import usersStorage from '../../../pages/Users/usersStorage';
import chatStorage from '../../../pages/Chat/chatStorage';
import authStorage from '../../../storages/mobx/authStorage';
import { requestPost } from '../../../services/real.backend';

function ModalGetManagerLink({
  t,
}) {
  const linkText = 'Добрый день. Это Школа «Реабилитолог». Мы меняем канал связи в вайбере. Чтобы продолжить дальнейшее общение с Вашим персональным консультантом, перейдите пожалуйста по ссылке. ';
  // const linkText = '';
  const [phone, setPhone] = useState('');
  const [contactID, setContactID] = useState(null);
  const closeWindow = () => {
    setContactID(null);
    setPhone(null);
    chatStorage.toggleManagerLinkDialog();
  };
  const saveContact = () => {
    requestPost('/api/contacts/create', {
      phone,
    })
      .then((resp) => {
        if (resp && resp.contactID) {
          setContactID(resp.contactID);
        } else {
          toast.error(t(`validation.${resp ? (resp.message || 'Error') : 'Error'}`));
        }
      });
  };
  return (
    <Modal isOpen={chatStorage.managerLinkDialogOpened} toggle={closeWindow}>
      <ModalHeader toggle={closeWindow}>
        {t("chat.Get manager's link")}
      </ModalHeader>
      <ModalBody>
        {!contactID && (
          <>
            {t('Phone')}
            <input className="form-control" onInput={(e) => setPhone(e.currentTarget.value)} />
            <StandardButton onClick={saveContact} id="addPhone">{t('Save')}</StandardButton>
          </>
        )}
        {contactID && chatStorage.managerLinks.map((linkItem) => (
          <div>
            {linkItem.type}
            {' '}
            {linkItem.title}
            <input className="form-control" value={`${linkText} ${linkItem.link}/cont-${contactID}`} />
            <StandardButton
              className="btn-secondary"
              onClick={() => {
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                  navigator.clipboard.writeText(`${linkText} ${linkItem.link}/cont-${contactID}`);
                  toast.info(t('Link copied to clipboard'));
                } else {
                  toast.error(t('Clipboard is not supported by browser'));
                }
              }}
            >
              {t('Copy')}
            </StandardButton>
          </div>
        ))}
      </ModalBody>
      <ModalFooter>
        <div className="button-group-mb-sm">
          <StandardButton
            className="btn-secondary"
            onClick={closeWindow}
          >
            {t('Cancel')}
          </StandardButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}

ModalGetManagerLink.propTypes = {};

export default translate(observer(ModalGetManagerLink));
